import { useLanguage, SUPPORTED_LANGUAGES } from '@/lib/i18n/LanguageContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Globe } from 'lucide-react';

export function LanguageToggle({ variant = 'default' }) {
  const { lang, setLang } = useLanguage();
  const current = SUPPORTED_LANGUAGES.find(l => l.code === lang) || SUPPORTED_LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="language-toggle"
          variant="ghost"
          size="sm"
          className={`gap-1.5 text-sm font-medium ${
            variant === 'nav'
              ? 'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]'
              : ''
          }`}
        >
          <Globe className="w-4 h-4" />
          <span className="uppercase tabular-nums">{lang.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[hsl(var(--card))] border-[hsl(var(--border))] max-h-[400px] overflow-y-auto w-48"
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`gap-2 cursor-pointer ${lang === l.code ? 'bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))]' : ''}`}
          >
            <span className="text-base">{l.flag}</span>
            <span className="font-medium">{l.name}</span>
            <span className="text-xs text-[hsl(var(--muted-foreground))] ml-auto uppercase">{l.code}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
